import { render } from "./aTo.vue?vue&type=template&id=51a6770d"
import script from "./aTo.vue?vue&type=script&lang=js"
export * from "./aTo.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__